import React from 'react'
import {Link} from 'react-router-dom'
import {bindActionCreators} from 'redux'
import {push} from 'react-router-redux'
import {connect} from 'react-redux'

import config from '../../config.js'

import 'Skelet/src/start.css'; // importing this seems to make it get stuck, so even on other routes and containers the css is still there.

import {setMetatags} from '../../modules/metatag_functions.js'
import {toggleDropdown, openModal, closeModal} from 'Skelet/src/modules/functions.js'
import ModalAccount from 'Skelet/src/components/ModalAccount.js'
import logo from '../../images/logo-dieetclub.png';
import StartFooterCTA from '../StartPages/StartFooterCTA.js'
import StartFooterSocials from '../StartPages/StartFooterSocials.js'
import StartFooter from 'Skelet/src/components/Start_Footer.js'
import CompanyFooter from 'Skelet/src/components/Company_Footer.js'

// todo: change buttons to anchors

class StartRoute extends React.Component {

  constructor(props) {
    super(props);

    let modal_open = false;
    let modal_content = "login";
    let reset_token = null;
    if(typeof URLSearchParams === "function") {
      let params = new URLSearchParams(this.props.location.search);
      let param_login = params.get('login');
      let param_reset = params.get('reset');
      let param_verify = params.get('verify'); // this won't be from an e-mail, but might be helpful to manually trigger when bugged.
      if(param_login === "") {
        modal_open = true;
      } else if(param_reset !== null) {
        modal_open = true;
        modal_content = "reset";
        reset_token = params.get('token');
      } else if(param_verify !== null) {
        modal_open = true;
        modal_content = "verify";
      }
    }

    this.state = {modal_open:modal_open, modal_content:modal_content, reset_token:reset_token, dropdown_open:false};

    // this.setWrapperRef = this.setWrapperRef.bind(this);
    // this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  // componentDidMount() {
  //   document.addEventListener('mousedown', this.handleClickOutside);
  // }

  // componentWillUnmount() {
  //   document.removeEventListener('mousedown', this.handleClickOutside);
  // }

  // setWrapperRef(node) {
  //   this.wrapperRef = node;
  // }

// this doesn't work with the responsive menu, as the other/big-screen buttons are seen as "outside" the menu, and therefore blocked.
  // handleClickOutside(event) {
  //   if(this.wrapperRef && !this.wrapperRef.contains(event.target)) {
  //     this.setState({dropdown_open:false});
  //   }
  // }

  render() {
    setMetatags();
    const Navbar = () => <header className=""><div className="container">
      <div className="primary">
        <Link to="/start" onClick={() => document.getElementById("main").scrollIntoView(true)} className="logo"><img src={logo} alt={config.app_id}/></Link>
      </div>
      <div className="secondary">
        <nav className="navigation">
          <ol>
            <li className={"md-shown nav-item" + ((this.props.pathname === "/start") ? " current" : "")}><a href="/start" className="btn btn-fat">start</a></li>
            <li className={"md-shown nav-item" + ((this.props.pathname === "/blogs") ? " current" : "")}><a href="/blogs" className="btn btn-fat">blogs</a></li>
            {/*<li className={"md-shown nav-item" + ((this.props.pathname === "/recepten") ? " current" : "")}><button onClick={() => {document.getElementById("main").scrollIntoView(true);this.props.push("/recepten")}} className="btn btn-fat">recepten</button></li>*/}
            {/*<li className={"nav-item" + ((this.props.pathname === "/weekmenu") ? " current" : "")}><button onClick={() => {document.getElementById("main").scrollIntoView(true);this.props.push("/weekmenu")}} className="btn btn-offset btn-fat">weekmenu&#39;s</button></li>*/}
            {!this.props.session_token && <li className="md-shown nav-item"><button onClick={() => {openModal(this)}} className="btn btn-fat">inloggen</button></li>}
            {!this.props.session_token && <li className="md-shown nav-item"><button onClick={() => {openModal(this, null, "register")}} className="btn btn-fat btn-e">account maken</button></li>}
            {this.props.session_token && <li className="md-shown nav-item"><button onClick={() => {document.getElementById("main").scrollIntoView(true);this.props.push("/")}} className="btn btn-b">naar app</button></li>}
            {/*<li className={"md-hidden dropdown" + ((this.state.dropdown_open) ? " open" : "")} ref={this.setWrapperRef}>*/}
            <li className={"md-hidden dropdown" + ((this.state.dropdown_open) ? " open" : "")}>
              <button onClick={() => toggleDropdown(this)} className="btn" style={{border:"0", color:"#000", padding:"4px"}}><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" style={{height:"32px"}}><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" /></svg></button>
              <div className="dropdown-menu">
                <div className="dropdown-caret">
                  <span className="caret-outer"></span>
                  <span className="caret-inner"></span>
                </div>
                <ul style={{textAlign:"center"}}>
                  <li className={"nav-item" + ((this.props.pathname === "/start") ? " current" : "")}><button onClick={() => {toggleDropdown(this);document.getElementById("main").scrollIntoView(true);this.props.push("/start")}} className="btn btn-fat">start</button></li>
                  <li className={"nav-item" + ((this.props.pathname === "/blogs") ? " current" : "")}><button onClick={() => {toggleDropdown(this);document.getElementById("main").scrollIntoView(true);this.props.push("/blogs")}} className="btn btn-fat">blogs</button></li>
                  {/*<li className={"nav-item" + ((this.props.pathname === "/recepten") ? " current" : "")}><button onClick={() => {toggleDropdown(this);document.getElementById("main").scrollIntoView(true);this.props.push("/recepten")}} className="btn btn-fat">recepten</button></li>*/}
                  {/*<li className={"nav-item" + ((this.props.pathname === "/weekmenu") ? " current" : "")}><button onClick={() => {toggleDropdown(this);document.getElementById("main").scrollIntoView(true);this.props.push("/weekmenu")}} className="btn btn-offset btn-fat">weekmenu&#39;s</button></li>*/}
                  {!this.props.session_token && <li className="nav-item"><button onClick={() => {toggleDropdown(this);openModal(this)}} className="btn btn-fat">inloggen</button></li>}
                  {!this.props.session_token && <li className="nav-item"><button onClick={() => {toggleDropdown(this);openModal(this, null, "register")}} className="btn btn-fat btn-e">account maken</button></li>}
                  {this.props.session_token && <li className="nav-item"><button onClick={() => {toggleDropdown(this);document.getElementById("main").scrollIntoView(true);this.props.push("/")}} className="btn btn-b">naar app</button></li>}
                </ul>
              </div>
            </li>
          </ol>
        </nav>
      </div>
    </div></header>;

    return (
      <div>
        <div className="start">
        <ModalAccount shouldShow={this.state.modal_open} close={() => closeModal(this)} modal_content={this.state.modal_content} reset_token={this.state.reset_token} config={config} header={config.app_id} headerimg={logo} />
          <Navbar />
          <main>
            {/*<Route {...this.props} abc="def" />
            this doesn't pass the props, except for the [this.props], which are passed down from app.js
            cloneElement crashes because of an undefined error, even though it does work with CREATEelement.. */}
            {React.createElement(this.props.component, {
              openModal: (modal_content) => openModal(this, null, modal_content),
              config,
              session_token: this.props.session_token,
              push: this.props.push
            })}
            {/*this.props.children && React.cloneElement(this.props.children, {
              openModal: this.openModal
            })*/}
          <StartFooterCTA openModal={() => openModal(this, null, "register")} logged_in={!!this.props.session_token} />
          </main>
          {/* todo: weekmenu's hier ook weer toevoegen :) */}
          <CompanyFooter site="Dieet.Club" sitemap={{"Start":"/start", "Blogs":"/blogs", "Clublid Prijzen":"/prijzen"}} custom_first_col={<div key="21" className="col-3"><h2>Word Clublid!</h2><p className="max80-md">Naast alle geweldige gratis voordelen krijg je als Clublid nóg meer! Steun de ontwikkeling van Dieet.Club en krijg exclusief toegang tot publicaties van andere Clubleden. Als Clublid kun je namelijk recepten, blogs, status-berichten en mijlpalen delen!<br/><br/>Voor slechts een paar euro per maand ben je al lid, <a href="/prijzen" target="_blank">klik hier</a> voor meer informatie.</p></div>} />
          <StartFooterSocials />
          <StartFooter />
        </div>
      </div>
    );
  }

}


function mapStateToProps(state, ownProps) {
  let session_token = null;
  if(state.apiData["login"] !== undefined && (state.apiData["login"]["data"]["token"] !== undefined || state.apiData["login"]["data"]["token"] === null)) {
    session_token = state.apiData["login"]["data"]["token"];
  }
  return {
    session_token: session_token,
    pathname: ownProps.location.pathname
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    push,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(StartRoute)



// WEBPACK FOOTER //
// ./src/containers/route-containers/StartRoute.js